import {WorkloadCount} from '@/types/types';
import {ResourceFunction, OrganisationDeploymentState} from '@cquential/api';
import Dates from '@cquential/date-utils';

export default class WorkloadCounter {
    private data: Record<number, Record<string, WorkloadCount>> = {};
    private readonly shiftAlternativeTree: Record<number, number[]>; // shift id -> one or more shift id mapping
    private readonly organisationDeploymentStates: Record<number, OrganisationDeploymentState>;

    constructor(shiftAlternativeTree: Record<number, number[]>, organisationDeploymentStates: Record<number, OrganisationDeploymentState>) {
        this.shiftAlternativeTree = shiftAlternativeTree;
        this.organisationDeploymentStates = organisationDeploymentStates;
    }

    public get counts(): Record<number, Record<string, WorkloadCount>> {
        return this.data;
    }

    public initializeShift(shiftId: number): void {
        if (!this.data[shiftId]) {
            this.data[shiftId] = {};
        }
    }

    public incrementCount(shiftId: number, stateId: number | undefined, date: Date, functions?: ResourceFunction[], preventRecursion: number[] = []): void {
        if (typeof stateId !== 'undefined' && !this.organisationDeploymentStates[stateId].properties.fulfillsRequiredShift) {
            return; // do nothing
        }

        if (preventRecursion.indexOf(shiftId) >= 0) {
            return; // already did this shift, so stop following the tree
        }
        preventRecursion.push(shiftId);

        this.initializeShift(shiftId);

        const formattedDate: string = Dates.Formatter.formatDateComputerFriendly(date);

        // If object.date does not exist, create it
        if (!this.data[shiftId][formattedDate]) {
            this.data[shiftId][formattedDate] = {
                count: 0,
                functions: {},
            };
        }

        this.data[shiftId][formattedDate].count += 1;
        // Add
        if (functions) {
            for (const resourceFunction of functions) {
                // If object.functions does not exist, create it
                if (!this.data[shiftId][formattedDate].functions) {
                    this.data[shiftId][formattedDate].functions = {};
                }
                // If object.id does not exist, create it and assign value, else plus up the value
                if (!this.data[shiftId][formattedDate].functions[resourceFunction.id!]) {
                    this.data[shiftId][formattedDate].functions[resourceFunction.id!] = 1;
                } else {
                    this.data[shiftId][formattedDate].functions[resourceFunction.id!] += 1;
                }
            }
        }

        if (this.shiftAlternativeTree[shiftId]) {
            // and/or parents: increment the alternative counts
            for (const alternativeShiftId of this.shiftAlternativeTree[shiftId]) {
                this.incrementCount(alternativeShiftId, stateId, date, functions, preventRecursion.slice());
            }
        }
    }
}
